import {createContext, useState} from "react";

export const Context = createContext({});


export const Provider = props => {

    const {children} = props;
    const [show, setShow] = useState(false);
    const [announcements, setAnnouncements] = useState([])
    const [showDelete, setShowDelete] = useState(false)
    const [showCreate, setShowCreate] = useState(false)
    const [showEdit, setShowEdit] = useState(false)
    const [selectedAnnouncement, setSelectedAnnouncement] = useState(null)
    const [announcementToBeDeleted, setAnnouncementToBeDeleted] = useState(null)
    const [draggedItemIndex, setDraggedItemIndex] = useState(null)


    const WebAnnouncementsContext = {
        announcements,
        setAnnouncements,
        show,
        setShow,
        showDelete,
        setShowDelete,
        showCreate,
        setShowCreate,
        showEdit,
        setShowEdit,
        selectedAnnouncement,
        setSelectedAnnouncement,
        announcementToBeDeleted,
        setAnnouncementToBeDeleted,
        draggedItemIndex,
        setDraggedItemIndex
    }

    return <Context.Provider value={WebAnnouncementsContext}>{children}</Context.Provider>

};

export const {Consumer} = Context;
